import { ACCESS_TOKEN_COOKIE } from '@r1-frontend/shared/constants';
import { isServerSide } from '@r1-frontend/shared/helpers/ssr';
import axios from 'axios';
import { stringify } from 'qs';
import cookies from 'react-cookies';

import { NO_CACHE_COOKIE } from '~/src/constants';

/**
 * Запрос в ApiContent
 */
const axiosContent = axios.create({
    baseURL: isServerSide()
        ? process.env.NEXT_PUBLIC_HOST_API_CONTENT_INNER || process.env.NEXT_PUBLIC_HOST_API_CONTENT
        : process.env.NEXT_PUBLIC_HOST_API_CONTENT,
});

axiosContent.interceptors.request.use(
    (config) => {
        const token = cookies.load(ACCESS_TOKEN_COOKIE);
        const noCacheKey = cookies.load(NO_CACHE_COOKIE);

        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
        };

        if (!config.headers['Authorization'] && token) {
            headers['Authorization'] = `Bearer ${ token }`;
        }

        if (noCacheKey) {
            headers['no-cache-key'] = noCacheKey;
        }
        config.headers = { ...config.headers, ...headers };

        return config;
    },
    (error) => Promise.reject(error),
);

/**
 * @deprecated
 * @type {AxiosInstance}
 */
const contentRequest = Object.create(axiosContent);

contentRequest.get = async(url, options) => {
    if (options) {
        options.paramsSerializer = params => {
            return stringify(params);
        };
    }
    return axiosContent.get(url, options);
};
export default contentRequest;
